<template>
  <div class="vue-content">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { GoogleTagManagerService, GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  computed: {
    ...mapState({
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      isManagerPage: state => state.checkout.isManagerPage
    })
  },
  methods: {
    triggerLoadImages () {
      const allImages = document.querySelectorAll('[data-force-load="true"]')
      for (let image of allImages) {
        image.loading = 'eager'
      }
    }
  },
  mounted () {
    const translationParams = this.isManagerPage
      ? { ...window.translationParams, route: 'shop/checkout/index' }
      : window.translationParams
    this.$store.commit('SET_LANGUAGE', translationParams.language)
    this.$store.dispatch('INIT_EXACT_USER_LOCATION')

    GoogleTagManagerService.pushToDatalayer({ event: 'optimize.activate' })
    if (window.location.pathname.includes('/sale/')) {
      sessionStorage.setItem(`listForAnalytics`, `Specjalne oferty`)
    }
    window.onload = this.triggerLoadImages

    // При открытии страницы
    let analyticsLastTimestamp = localStorage.getItem('analyticsLastTimestamp')
    if (!analyticsLastTimestamp || Date.now() - parseInt(analyticsLastTimestamp) > 86400000) {
      localStorage.setItem('analyticsLastTimestamp', Date.now().toString())
      localStorage.setItem('openTabs', '0')
      localStorage.setItem('clickedBanners', JSON.stringify([]))
      localStorage.setItem('bannerPromoItems', JSON.stringify({}))
      localStorage.setItem('savedLists', JSON.stringify([]))
      localStorage.setItem('analyticsDataReferrer', JSON.stringify({}))
    }
    // window.addEventListener('load', function () {
    //   let openTabs = localStorage.getItem('openTabs') !== 'NaN' ? parseInt(localStorage.getItem('openTabs')) : 0
    //   localStorage.setItem('openTabs', openTabs + 1)
    // })

    // При закрытии вкладки
    // window.addEventListener('beforeunload', function () {
    //   let openTabs = parseInt(localStorage.getItem('openTabs'))
    //
    //   if (openTabs === 1) {
    //     // Это последняя вкладка — очищаем localStorage
    //     localStorage.setItem('clickedBanners', JSON.stringify([]))
    //     localStorage.setItem('bannerPromoItems', JSON.stringify({}))
    //     localStorage.setItem('savedLists', JSON.stringify([]))
    //   } else {
    //     // Уменьшаем счетчик вкладок
    //     localStorage.setItem('openTabs', openTabs - 1)
    //   }
    // })
    if (GoogleEnhancedEcommerce.isEnabled && (!localStorage.getItem('analyticsDataReferrer') || Object.keys(JSON.parse(localStorage.getItem('analyticsDataReferrer'))).length === 0)) {
      GoogleEnhancedEcommerce.collectUserAnalyticsData()
    }
  }
}
</script>

<style lang="sass">

.vue-content
  width: 100%

.arrow-down
  background: transparent
  border: solid black
  border-width: 0 2px 2px 0
  display: inline-block
  padding: 3px
  transform: rotate(45deg)
  position: absolute
  right: 20px
  top: 25px
  height: 10px
  width: 10px
  transition: .2s

.map-vue img
  border: 0!important
</style>
